import React, { useContext } from 'react';
import { HistoryStateContext } from '../providers/HistoryProvider';

function Tab({ id, active, onClick }) {
  const historyState = useContext(HistoryStateContext);
  const tabState = historyState[id];
  const { icon, title } = tabState.current;

  return (
    <div id={id} onClick={onClick} className={`chrome-tab  ${active ? 'active' : ''}`}>
      <div className="chrome-tab--leftbg"></div>
      <div className="chrome-tab--middle">
        {icon && <div className="chrome-tab-icon">
          <img src={icon}></img>
        </div>}
        <div className={`chrome-tab-title ${icon ? 'with-icon' : ''}`}>{title}</div>
        <div className="chrome-tab-close">
          <i className="icofont-close"></i>
        </div>
      </div>
      <div className="chrome-tab--rightbg"></div>
    </div>
  );
}

export default Tab;
